import { call, put } from 'redux-saga/effects';

import { ContentAPI } from 'services/content.api';
import {
  content,
  categoryContents,
  setContentStatus,
  setContentCategoryStatus,
  incrementContentCategoryPage,
  resetContentCategory,
} from 'actions/content.actions';
import { ActionType } from 'interfaces';
import { LOADING_STATUS } from 'constants/status';

export function* getContentSaga({ payload }: ActionType): unknown {
  const { id } = payload;
  try {
    yield put(setContentStatus(LOADING_STATUS.PENDING));
    const { data } = yield call(ContentAPI.getContent, id);
    yield put(content.success({ id, content: data }));
    yield put(setContentStatus(LOADING_STATUS.RESOLVED));
  } catch (error) {
    yield put(content.failure({ id, error }));
    yield put(setContentStatus(LOADING_STATUS.REJECTED));
  }
}

export function* getCategoryContentsSaga({ payload }: ActionType): unknown {
  const { id, page } = payload;
  try {
    if (page === 1) {
      yield put(resetContentCategory());
    }
    yield put(setContentCategoryStatus(LOADING_STATUS.PENDING));
    const { data } = yield call(ContentAPI.getCategoryContents, id, page);
    yield put(categoryContents.success({ categoryContents: data }));
    yield put(incrementContentCategoryPage());
    yield put(setContentCategoryStatus(LOADING_STATUS.RESOLVED));
  } catch (error) {
    yield put(categoryContents.failure({ error }));
    yield put(setContentCategoryStatus(LOADING_STATUS.RESOLVED));
  }
}
